export default __webpack_public_path__ + "static/media/heart.a5dc1d27.svg";